import format from 'date-fns/format'
import React from 'react'
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom'

import s from './CreativeInfoModal.module.scss'

import { ControlledStreamInfo } from './components/ControlledStreamInfo/ControlledStreamInfo'

import transformUTCToLocale from 'utils/transformUTCToLocale'

import { useFetch } from 'hooks/useFetch'

import { creativesApi } from 'api/creatives-api'

import { CustomButton } from 'components/UI/CustomButton/CustomButton'
import { ModalFullScreen } from 'components/UI/ModalFullScreen/ModalFullScreen'

import { createCreativeDescription } from 'pages/MyCreatives/helpers/createCreativeDescription'

const CreativeInfoModal = () => {
  const [searchParams] = useSearchParams()
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  const { data: creative, loading } = useFetch({
    getData: () => creativesApi.getOne(+(id || 0)),

    deps: [id],
  })
  const { data: streamData, loading: streamLoading } = useFetch({
    getData: () => creativesApi.getStreamData(+(id || 0)),
    fetchIf: creative?.creative_type === 3,
    deps: [id, creative?.creative_type],
  })

  const onCloseModal = () => {
    navigate(`../?${searchParams}`, { replace: true })
  }
  const editCreativeHandler = () => {
    navigate(`../edit/${creative?.id}?${searchParams}`)
  }

  return (
    <ModalFullScreen
      onHide={onCloseModal}
      loading={loading || streamLoading}
      className={s.modalWrapper}
      testid="creative-modal"
    >
      <div></div>
      <div className={s.modalContent}>
        <div className={s.imageWrapper}>
          <img src={creative?.thumbnail} alt="" className={s.creativeImage} />
        </div>
        <div className={s.col}>
          <h3 className={s.header}>{creative?.name}</h3>
          <p className={s.about}>{createCreativeDescription(creative)}</p>
          <p className={`${s.descriptionP} ${s.text}`}>{creative?.description}</p>
          <p className={s.date}>
            {creative?.created_at
              ? `Created at ${format(transformUTCToLocale(creative?.created_at), 'MMM dd yyyy HH:mm')}`
              : null}
          </p>
          {creative?.creative_type === 3 ? <ControlledStreamInfo streamData={streamData} /> : null}
        </div>
      </div>
      <div className={s.buttonsWrapper}>
        {location.pathname.includes('my-creatives') ? (
          <CustomButton variant="primary" onClick={editCreativeHandler} size="240" className={s.editBtn}>
            Edit
          </CustomButton>
        ) : null}
        <CustomButton variant="outlined" onClick={onCloseModal} size="152" className={s.cancelBtn}>
          Close
        </CustomButton>
      </div>
    </ModalFullScreen>
  )
}

export default CreativeInfoModal
